/**
 * Конфигурация брендов для мультибрендовой системы тем.
 * Бренд выбирается через переменную окружения VITE_BRAND.
 * По умолчанию используется 'default' (АСУБП).
 */

export interface BrandConfig {
  id: string;
  name: string;
  shortName: string;
  systemName: string;
  primary: string;
  primaryDark: string;
  primaryLight: string;
  secondary: string;
  accent: string;
  error: string;
  success: string;
  warning: string;
  sidebarBg: { dark: string; light: string };
  sidebarActiveBg: { dark: string; light: string };
  logoColor: string;
  /** Logo for light backgrounds */
  logoUrl: string | null;
  /** Logo for dark backgrounds */
  logoDarkUrl: string | null;
  /** Small icon logo */
  logoIconUrl: string | null;
  fontFamily: string;
  headingFontFamily: string;
  footerText: string;
  aircraft: string;
  loginGradient: { dark: string; light: string };
  loginAccent: string;
}

export const BRANDS: Record<string, BrandConfig> = {
  default: {
    id: 'default',
    name: 'АСУБП',
    shortName: 'АБДСУБП',
    systemName: 'Система управления безопасностью полётов',
    primary: '#3B82F6',
    primaryDark: '#2563EB',
    primaryLight: '#60A5FA',
    secondary: '#8B5CF6',
    accent: '#10B981',
    error: '#EF4444',
    success: '#10B981',
    warning: '#F59E0B',
    sidebarBg: { dark: '#0f172a', light: '#ffffff' },
    sidebarActiveBg: { dark: 'rgba(59,130,246,0.12)', light: 'rgba(59,130,246,0.08)' },
    logoColor: '#3B82F6',
    logoUrl: null,
    logoDarkUrl: null,
    logoIconUrl: null,
    fontFamily: '"Inter", sans-serif',
    headingFontFamily: '"Inter", sans-serif',
    footerText: 'Автоматизированная база данных системы управления безопасностью полётов',
    aircraft: 'Falcon 7X/900 \u00b7 Gulfstream G550/G650 \u00b7 Challenger 650 \u00b7 AW139',
    loginGradient: { dark: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)', light: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 50%, #dbeafe 100%)' },
    loginAccent: '#3B82F6',
  },
  nordwind: {
    id: 'nordwind',
    name: 'Nordwind Airlines',
    shortName: 'Nordwind',
    systemName: 'Система управления безопасностью полётов',
    primary: '#CD202C',
    primaryDark: '#A91B23',
    primaryLight: '#E8515A',
    secondary: '#1A1A2E',
    accent: '#F59E0B',
    error: '#DC2626',
    success: '#059669',
    warning: '#D97706',
    sidebarBg: { dark: '#1A1A2E', light: '#FAFAFA' },
    sidebarActiveBg: { dark: 'rgba(227,30,36,0.15)', light: 'rgba(227,30,36,0.08)' },
    logoColor: '#CD202C',
    logoUrl: '/brands/nordwind/logo.svg',
    logoDarkUrl: '/brands/nordwind/logo-white.svg',
    logoIconUrl: '/brands/nordwind/logo-icon.svg',
    fontFamily: '"Montserrat", "Inter", sans-serif',
    headingFontFamily: '"Montserrat", "Inter", sans-serif',
    footerText: 'Система управления безопасностью полётов — Nordwind Airlines',
    aircraft: 'Boeing 737 \u00b7 Boeing 767 \u00b7 Boeing 777 \u00b7 Airbus A321',
    loginGradient: { dark: 'linear-gradient(135deg, #1A1A2E 0%, #2D1B3D 30%, #1A1A2E 60%, #0D0D1A 100%)', light: 'linear-gradient(135deg, #FEF2F2 0%, #FEE2E2 50%, #FFF7ED 100%)' },
    loginAccent: '#E31E24',
  },
};

export function getBrand(): BrandConfig {
  const brandId = import.meta.env.VITE_BRAND || 'default';
  return BRANDS[brandId] || BRANDS.default;
}
